import SpzLogo from "@/assets/logo-spz.svg";
import { Button } from "@spz/ui/components/button";
import { Typography } from "@spz/ui/components/typography";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const ServiceUnavailablePage: React.FC = () => {
  const { t } = useTranslation();
  const [isReloading, setIsReloading] = useState(false);

  const handleReload = () => {
    setIsReloading(true);
    window.location.reload();
  };

  return (
    <div className="h-screen">
      <div className="flex items-center justify-center h-full bg-gray-50 rounded-md overflow-auto">
        <div className="flex flex-col w-full max-w-[534px] mx-6 gap-6">
          <div>
            <img src={SpzLogo} alt="SpzLogo" className="w-[172px]" />
          </div>
          <div className="flex flex-col gap-2">
            <Typography variant="h3">{t("maintenance_title")}</Typography>

            <Typography className="text-gray-700">
              {t("maintenance_message")}
            </Typography>
          </div>
          <div>
            <Button
              onClick={handleReload}
              variant="primary"
              leftIcon="rotate-ccw"
              loading={isReloading}
            >
              {t("maintenance_reload_button")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceUnavailablePage;
